// proto/v2/auth/auth.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file auth/auth.proto (package lvdr.v2.auth, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auth/auth.proto.
 */
export const file_auth_auth: GenFile = /*@__PURE__*/
  fileDesc("Cg9hdXRoL2F1dGgucHJvdG8SDGx2ZHIudjIuYXV0aCJOChpCZWdpbkF1dGhlbnRpY2F0aW9uUmVxdWVzdBINCgV0b2tlbhgBIAEoCRIOCgZvcmdfaWQYAiABKAkSEQoJZGV2aWNlX2lkGAMgASgJIjMKHUNvbXBsZXRlQXV0aGVudGljYXRpb25SZXF1ZXN0EhIKCmNyZWRlbnRpYWwYASABKAkiKQoYQmVnaW5SZWdpc3RyYXRpb25SZXF1ZXN0Eg0KBXRva2VuGAEgASgJIjEKG0NvbXBsZXRlUmVnaXN0cmF0aW9uUmVxdWVzdBISCgpjcmVkZW50aWFsGAEgASgJIg8KDUxvZ291dFJlcXVlc3QiLgobUmVnaXN0cmF0aW9uT3B0aW9uc1Jlc3BvbnNlEg8KB29wdGlvbnMYASABKAwiMAodQXV0aGVudGljYXRpb25PcHRpb25zUmVzcG9uc2USDwoHb3B0aW9ucxgBIAEoDCJrCh1BdXRoZW50aWNhdGlvblN1Y2Nlc3NSZXNwb25zZRIPCgd1c2VyX2lkGAEgASgJEgwKBHJvbGUYAiABKAkSFAoMYWNjZXNzX3Rva2VuGAMgASgJEhUKDXJlZnJlc2hfdG9rZW4YBCABKAkiIQoOTG9nb3V0UmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCCI5ChNTZXNzaW9uUmV2b2tlZEV2ZW50Eg4KBnJlYXNvbhgBIAEoCRISCgpyZXZva2VkX2F0GAIgASgDIh0KG0dldFN1YnNjcmlwdGlvblN0YXRlUmVxdWVzdCKRAQocR2V0U3Vic2NyaXB0aW9uU3RhdGVSZXNwb25zZRIRCgl0aWVyX25hbWUYASABKAkSMAoGc3RhdHVzGAIgASgOMiAubHZkci52Mi5hdXRoLlN1YnNjcmlwdGlvblN0YXR1cxIRCglyZW5ld3NfYXQYAyABKAMSGQoRcG9sYXJfY3VzdG9tZXJfaWQYBCABKAkqwgEKElN1YnNjcmlwdGlvblN0YXR1cxIjCh9TVUJTQ1JJUFRJT05fU1RBVFVTX1VOU1BFQ0lGSUVEEAASHgoaU1VCU0NSSVBUSU9OX1NUQVRVU19BQ1RJVkUQARIiCh5TVUJTQ1JJUFRJT05fU1RBVFVTX0NBTkNFTExJTkcQAhIhCh1TVUJTQ1JJUFRJT05fU1RBVFVTX0NBTkNFTExFRBADEiAKHFNVQlNDUklQVElPTl9TVEFUVVNfUEFTVF9EVUUQBEIlWiNnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvYXV0aGIGcHJvdG8z");

/**
 * @generated from message lvdr.v2.auth.BeginAuthenticationRequest
 */
export type BeginAuthenticationRequest = Message<"lvdr.v2.auth.BeginAuthenticationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;
};

/**
 * Describes the message lvdr.v2.auth.BeginAuthenticationRequest.
 * Use `create(BeginAuthenticationRequestSchema)` to create a new message.
 */
export const BeginAuthenticationRequestSchema: GenMessage<BeginAuthenticationRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 0);

/**
 * @generated from message lvdr.v2.auth.CompleteAuthenticationRequest
 */
export type CompleteAuthenticationRequest = Message<"lvdr.v2.auth.CompleteAuthenticationRequest"> & {
  /**
   * @generated from field: string credential = 1;
   */
  credential: string;
};

/**
 * Describes the message lvdr.v2.auth.CompleteAuthenticationRequest.
 * Use `create(CompleteAuthenticationRequestSchema)` to create a new message.
 */
export const CompleteAuthenticationRequestSchema: GenMessage<CompleteAuthenticationRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 1);

/**
 * @generated from message lvdr.v2.auth.BeginRegistrationRequest
 */
export type BeginRegistrationRequest = Message<"lvdr.v2.auth.BeginRegistrationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message lvdr.v2.auth.BeginRegistrationRequest.
 * Use `create(BeginRegistrationRequestSchema)` to create a new message.
 */
export const BeginRegistrationRequestSchema: GenMessage<BeginRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 2);

/**
 * @generated from message lvdr.v2.auth.CompleteRegistrationRequest
 */
export type CompleteRegistrationRequest = Message<"lvdr.v2.auth.CompleteRegistrationRequest"> & {
  /**
   * @generated from field: string credential = 1;
   */
  credential: string;
};

/**
 * Describes the message lvdr.v2.auth.CompleteRegistrationRequest.
 * Use `create(CompleteRegistrationRequestSchema)` to create a new message.
 */
export const CompleteRegistrationRequestSchema: GenMessage<CompleteRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 3);

/**
 * @generated from message lvdr.v2.auth.LogoutRequest
 */
export type LogoutRequest = Message<"lvdr.v2.auth.LogoutRequest"> & {
};

/**
 * Describes the message lvdr.v2.auth.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 4);

/**
 * @generated from message lvdr.v2.auth.RegistrationOptionsResponse
 */
export type RegistrationOptionsResponse = Message<"lvdr.v2.auth.RegistrationOptionsResponse"> & {
  /**
   * @generated from field: bytes options = 1;
   */
  options: Uint8Array;
};

/**
 * Describes the message lvdr.v2.auth.RegistrationOptionsResponse.
 * Use `create(RegistrationOptionsResponseSchema)` to create a new message.
 */
export const RegistrationOptionsResponseSchema: GenMessage<RegistrationOptionsResponse> = /*@__PURE__*/
  messageDesc(file_auth_auth, 5);

/**
 * @generated from message lvdr.v2.auth.AuthenticationOptionsResponse
 */
export type AuthenticationOptionsResponse = Message<"lvdr.v2.auth.AuthenticationOptionsResponse"> & {
  /**
   * @generated from field: bytes options = 1;
   */
  options: Uint8Array;
};

/**
 * Describes the message lvdr.v2.auth.AuthenticationOptionsResponse.
 * Use `create(AuthenticationOptionsResponseSchema)` to create a new message.
 */
export const AuthenticationOptionsResponseSchema: GenMessage<AuthenticationOptionsResponse> = /*@__PURE__*/
  messageDesc(file_auth_auth, 6);

/**
 * @generated from message lvdr.v2.auth.AuthenticationSuccessResponse
 */
export type AuthenticationSuccessResponse = Message<"lvdr.v2.auth.AuthenticationSuccessResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;
};

/**
 * Describes the message lvdr.v2.auth.AuthenticationSuccessResponse.
 * Use `create(AuthenticationSuccessResponseSchema)` to create a new message.
 */
export const AuthenticationSuccessResponseSchema: GenMessage<AuthenticationSuccessResponse> = /*@__PURE__*/
  messageDesc(file_auth_auth, 7);

/**
 * @generated from message lvdr.v2.auth.LogoutResponse
 */
export type LogoutResponse = Message<"lvdr.v2.auth.LogoutResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message lvdr.v2.auth.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_auth_auth, 8);

/**
 * SessionRevokedEvent tells the client that its session has been invalidated
 * server-side and it must log out. Reason values:
 *   "logged_out_elsewhere" — user logged out from another tab/device
 *   "admin_revoked"        — admin force-revoked the session
 *   "key_rotated"          — DEK rotation invalidated active sessions
 *   "token_expired"        — server detected expired token on incoming message
 *
 * @generated from message lvdr.v2.auth.SessionRevokedEvent
 */
export type SessionRevokedEvent = Message<"lvdr.v2.auth.SessionRevokedEvent"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;

  /**
   * epoch ms
   *
   * @generated from field: int64 revoked_at = 2;
   */
  revokedAt: bigint;
};

/**
 * Describes the message lvdr.v2.auth.SessionRevokedEvent.
 * Use `create(SessionRevokedEventSchema)` to create a new message.
 */
export const SessionRevokedEventSchema: GenMessage<SessionRevokedEvent> = /*@__PURE__*/
  messageDesc(file_auth_auth, 9);

/**
 * Subscription state for the authenticated user. Frontend reads this on
 * /settings/account mount and refreshes on tierChangedEvent. See
 * docs/plans/2026-05-13-settings-restructure-design.md § Backend additions.
 *
 * @generated from message lvdr.v2.auth.GetSubscriptionStateRequest
 */
export type GetSubscriptionStateRequest = Message<"lvdr.v2.auth.GetSubscriptionStateRequest"> & {
};

/**
 * Describes the message lvdr.v2.auth.GetSubscriptionStateRequest.
 * Use `create(GetSubscriptionStateRequestSchema)` to create a new message.
 */
export const GetSubscriptionStateRequestSchema: GenMessage<GetSubscriptionStateRequest> = /*@__PURE__*/
  messageDesc(file_auth_auth, 10);

/**
 * @generated from message lvdr.v2.auth.GetSubscriptionStateResponse
 */
export type GetSubscriptionStateResponse = Message<"lvdr.v2.auth.GetSubscriptionStateResponse"> & {
  /**
   * "Free", "Pro", "Enterprise", etc.
   *
   * @generated from field: string tier_name = 1;
   */
  tierName: string;

  /**
   * @generated from field: lvdr.v2.auth.SubscriptionStatus status = 2;
   */
  status: SubscriptionStatus;

  /**
   * unix seconds; 0 if N/A (e.g. free tier)
   *
   * @generated from field: int64 renews_at = 3;
   */
  renewsAt: bigint;

  /**
   * optional, may be empty
   *
   * @generated from field: string polar_customer_id = 4;
   */
  polarCustomerId: string;
};

/**
 * Describes the message lvdr.v2.auth.GetSubscriptionStateResponse.
 * Use `create(GetSubscriptionStateResponseSchema)` to create a new message.
 */
export const GetSubscriptionStateResponseSchema: GenMessage<GetSubscriptionStateResponse> = /*@__PURE__*/
  messageDesc(file_auth_auth, 11);

/**
 * @generated from enum lvdr.v2.auth.SubscriptionStatus
 */
export enum SubscriptionStatus {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELLING = 2;
   */
  CANCELLING = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PAST_DUE = 4;
   */
  PAST_DUE = 4,
}

/**
 * Describes the enum lvdr.v2.auth.SubscriptionStatus.
 */
export const SubscriptionStatusSchema: GenEnum<SubscriptionStatus> = /*@__PURE__*/
  enumDesc(file_auth_auth, 0);

